import { createDevelopmentFetch, type DevelopmentPolicy } from './development-policy';

const env = import.meta.env;
const rawFetch = globalThis.fetch.bind(globalThis);
let guardedFetch: typeof fetch = rawFetch;
export const developmentMode = env.DEV ? env.VITE_PELIP_MODE as 'web' | undefined : undefined;
if (env.DEV) {
  if (developmentMode !== 'web') {
    throw new Error('Arranca Pelip con pelip.cmd -Accion Arrancar.');
  }
  const policy: DevelopmentPolicy = {
    mode: 'web',
    supabaseUrl: env.VITE_SUPABASE_URL || '',
    supabaseKey: env.VITE_SUPABASE_ANON_KEY || '',
    runtimeUrl: env.VITE_AGENT_RUNTIME_URL || '',
    users: (env.VITE_PELIP_TEST_USER_IDS || '').split(',').filter(Boolean),
    emails: (env.VITE_PELIP_TEST_EMAILS || '').toLowerCase().split(',').filter(Boolean),
  };
  guardedFetch = createDevelopmentFetch(policy, rawFetch, globalThis.location.origin, () => {
    try { return JSON.parse(localStorage.getItem('pelip-web-session') || '{}').access_token || ''; }
    catch { return ''; }
  });
}
export const developmentFetch: typeof fetch = (...args) => guardedFetch(...args);

export function installDevelopmentEnvironment(): void {
  if (!developmentMode) return;
  globalThis.fetch = developmentFetch;
  const banner = document.createElement('div');
  banner.setAttribute('role', 'status');
  banner.textContent = 'DESARROLLO · Servicios reales · Solo cuentas autorizadas';
  Object.assign(banner.style, {
    position: 'fixed', bottom: '0', left: '0', right: '0', zIndex: '2147483647',
    background: '#713f12', color: '#fff',
    padding: '7px 12px', font: '12px system-ui', textAlign: 'center', pointerEvents: 'none',
  });
  document.body.appendChild(banner);
}
